import React, { useEffect, useState } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Grid, Typography, Checkbox, Box, Button,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate, useLocation } from "react-router-dom";
import SearchBar from "../../../Common/UtilityCommon/SearchBar";
import PerPageSelect from "../../../Common/UtilityCommon/PerPageSelect";
import Pagination from "../../../Common/UtilityCommon/Pagination";
import CircularSpinner from "../../../Common/Spinners/CircularSpinner";
import axios from "axios";
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";
import CarryAuctionHelp from "../../../Helper/CarryToAuctionHelp";


const styles = {
    tableHeaderCell: {
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#f4f4f4",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
};

const API_URL = process.env.REACT_APP_API;

const CarryToAuctionUtility = ({ includeYearCode = true, rowKey = "AwakDetailId" }) => {

    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [perPage, setPerPage] = useState(15);
    const [currentPage, setCurrentPage] = useState(1);

    // ✔ Keep checkbox selections here (object)
    const [selectedRows, setSelectedRows] = useState({});

    // ✔ Keep Help popup selections here (array)
    const [selectedHelpRows, setSelectedHelpRows] = useState([]);
    const [lastSrNo, setLastSrNo] = useState(0);


    const navigate = useNavigate();
    const location = useLocation();

    const apiUrl = `${API_URL}/getdata-ForLockSauda`;

    // ----------------------------------------
    // Load Data
    // ----------------------------------------
    useEffect(() => {
        loadData();
    }, []);

    // const loadData = async () => {
    //     try {
    //         setLoading(true);

    //         const Company_Code = sessionStorage.getItem("Company_Code");
    //         const Year_Code = sessionStorage.getItem("Year_Code");

    //         const finalUrl = `${apiUrl}?Company_Code=${Company_Code}${includeYearCode ? `&Year_Code=${Year_Code}` : ""}`;
    //         const res = await axios.get(finalUrl);

    //         const data = res.data.all_data || [];

    //         setRows(data);
    //         setFilteredRows(data);

    //         // Preselect items that already have AuctionMark = Y
    //         const preSelected = {};
    //         data.forEach(row => {
    //             if (row.AuctionMark === "Y") {
    //                 preSelected[row[rowKey]] = true;
    //             }
    //         });

    //         setSelectedRows(preSelected);

    //     } catch (err) {
    //         console.error("Error fetching:", err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const loadData = async () => {
    //     try {
    //         setLoading(true);

    //         const Company_Code = sessionStorage.getItem("Company_Code");
    //         const Year_Code = sessionStorage.getItem("Year_Code");

    //         const finalUrl = `${apiUrl}?Company_Code=${Company_Code}${includeYearCode ? `&Year_Code=${Year_Code}` : ""}`;
    //         const res = await axios.get(finalUrl);

    //         const data = res.data.all_data || [];

    //         //  SHOW ONLY LOCKED RECORDS
    //         const lockedData = data.filter(row => row.AuctionMark === "Y");

    //         setRows(lockedData);
    //         setFilteredRows(lockedData);
    //         setSelectedHelpRows(lockedData);

    //     } catch (err) {
    //         console.error("Error fetching:", err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const loadData = async () => {
        try {
            setLoading(true);

            const Company_Code = sessionStorage.getItem("Company_Code");
            const Year_Code = sessionStorage.getItem("Year_Code");

            const finalUrl = `${apiUrl}?Company_Code=${Company_Code}${includeYearCode ? `&Year_Code=${Year_Code}` : ""}`;
            const res = await axios.get(finalUrl);

            const data = res.data.all_data || [];

            setRows(data);
            setFilteredRows(data);

            // Preselect items that already have AuctionMark = Y
            const preSelected = {};
            data.forEach(row => {
                if (row.AuctionMark === "Y") {
                    preSelected[row[rowKey]] = true;
                }
            });

            setSelectedRows(preSelected);

            const maxFromDB = Math.max(
                0,
                ...data.filter(r => r.SrNo).map(r => Number(r.SrNo))
            );

            setLastSrNo(maxFromDB);


        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };


    // ----------------------------------------
    // Toggle Row (checkbox)
    // ----------------------------------------
    const handleRowToggle = (rowId) => {
        setSelectedRows(prev => ({
            ...prev,
            [rowId]: !prev[rowId]
        }));
    };

    const excludeIds = new Set(
        selectedHelpRows.map(row => row[rowKey])
    );


    // ----------------------------------------
    // When Help Popup selects a row → store in array
    // ----------------------------------------
    // const handleHelpSelect = (row) => {
    //     setSelectedHelpRows(prev => {
    //         if (prev.some(r => r.AwakDetailId === row.AwakDetailId)) return prev;
    //         return [...prev, row];
    //     });
    // };


    const handleHelpSelect = (row) => {
        const today = new Date().toISOString().split("T")[0];

        setSelectedHelpRows(prev => {


            if (prev.some(r => r.AwakDetailId === row.AwakDetailId)) {
                return prev;
            }

            return [
                ...prev,
                {
                    ...row,


                    SaudaDate: row.SaudaDate || today
                }
            ];
        });
    };


    // ----------------------------------------
    // Filtering Search
    // ----------------------------------------
    useEffect(() => {
        const term = searchTerm.toLowerCase();

        const filtered = rows.filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(term)
            )
        );

        setFilteredRows(filtered);
        setCurrentPage(1);
    }, [searchTerm, rows]);

    const pageCount = Math.ceil(filteredRows.length / perPage);

    // ----------------------------------------
    // Save / Lock Sauda
    // ----------------------------------------
    // const handleCarryToAuction = async () => {
    //     const detailData = selectedHelpRows.map((row, index) => ({
    //         Id: Number(row[rowKey]),
    //         AuctionMark: "Y",
    //         SrNo: index + 1,
    //     }));


    //     try {
    //         await axios.put(`${API_URL}/Update_OnlyDetailAwakEntry`, { detailData });

    //         Swal.fire({ title: "Success!", text: "Updated", icon: "success" });

    //         // setTimeout(() => window.location.reload(), 1000);/getdata-ForLockSauda

    //     } catch (err) {
    //         console.error(err);
    //         alert("Saving failed");
    //     }
    // };

    const handleCarryToAuction = async () => {
        debugger
        const today = new Date().toISOString().split("T")[0];

        // rows already having SrNo = previously locked → DO NOT UPDATE
        // const alreadyLocked = selectedHelpRows.filter(r => r.SrNo);

        // only rows WITHOUT SrNo = new rows → update these only
        const newRows = selectedHelpRows.filter(r => !r.SrNo);

        // if (newRows.length === 0) {
        //     Swal.fire("No new records to update", "", "info");
        //     return;
        // }

        // find highest SrNo from already locked rows
        // const existingMaxSrNo = Math.max(
        //     0,
        //     ...alreadyLocked.map(r => Number(r.SrNo) || 0)
        // );

        let counter = lastSrNo;

        const detailData = newRows.map(row => {
            counter++;

            return {
                Id: Number(row[rowKey]),
                AuctionMark: "Y",
                SrNo: counter,
                SaudaDate: today,       // only for new records
            };
        });

        try {
            await axios.put(`${API_URL}/Update_OnlyDetailAwakEntry`, { detailData: detailData });

            Swal.fire("Success", "Only new records updated", "success");

            setTimeout(() => window.location.reload(), 1000);

            // loadData(); 

        } catch (err) {
            console.error(err);
            alert("Saving failed");
        }
    };


    const handleRemoveSelectedRow = (rowId) => {
        setSelectedHelpRows(prev =>
            prev.filter(row => row[rowKey] !== rowId)
        );
    };


    const handleExportToExcel = () => {
        if (selectedHelpRows.length === 0) {
            Swal.fire({ title: "No data!", text: "Please select rows first.", icon: "warning" });
            return;
        }


        const wb = XLSX.utils.book_new();

        const excelRows = [];


        excelRows.push(["SR No ", "Awak No ", "Farmer Code ", "Farmer Name ", "City ", "Qty ", "Item Name ", "GoDown Name ", "Line Name ", "Balance "]);


        selectedHelpRows.forEach((row, index) => {
            excelRows.push([
                index + 1,
                row.Doc_No,
                row.Ac_code,
                row.Ac_Name_E,
                row.city_name_e,
                row.Awak_Qty,
                row.Item,
                row.Godown,
                row.Line,
                row.balance,
            ]);
        });


        const ws = XLSX.utils.aoa_to_sheet(excelRows);


        XLSX.utils.book_append_sheet(wb, ws, "SelectedData");

        XLSX.writeFile(wb, "SelectedData.xlsx");
    };


    return (
        <>
            {/* HEADER */}
            <Grid container spacing={2} alignItems="center">
                {/* Per Page Selector */}
                <Grid item>
                    <PerPageSelect
                        value={perPage}
                        onChange={(e) => {
                            setPerPage(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                </Grid>

                {/* Help Popup */}
                <Grid item display="flex" alignItems="center" spacing={1}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", mr: 1 }}>
                        Awak No:
                    </Typography>
                    <CarryAuctionHelp
                        name="AwakNoHelp"
                        onAcCodeClick={handleHelpSelect}
                        excludeIds={[...excludeIds]}
                    />
                </Grid>

                <Button
                    variant="contained"
                    onClick={handleExportToExcel}
                    style={{
                        backgroundColor: "#3c9a43ff",
                        color: "white",
                        textTransform: "none",
                        fontWeight: "600",
                        padding: "6px 16px",
                        borderRadius: "6px",
                        boxShadow: "none",
                        marginTop: "18px"
                    }}
                    startIcon={<FileDownloadIcon />}
                >
                    Export to Excel
                </Button>



                {/* Center Title */}
                <Grid item xs display="flex" justifyContent="center">
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            ml: 10,
                            marginBottom: '10px',
                            padding: '12px 0',
                            position: 'relative',
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: '0',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '80px',
                                height: '4px',
                                background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                                borderRadius: '2px',
                                animation: 'underlineGrow 0.5s ease-out forwards'
                            },
                            '@keyframes underlineGrow': {
                                '0%': { width: '0' },
                                '100%': { width: '80px' }
                            }
                        }}
                    >
                        Carry To Auction List
                    </Typography>
                </Grid>

                {/* Search Bar */}
                <Grid item xs={12} sm={4}>
                    <SearchBar
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Grid>
            </Grid>

            {/* TABLE OF HELP SELECTIONS */}
            <Paper sx={{ mt: 2 }}>
                <TableContainer sx={{ maxHeight: "70vh" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow sx={{ height: 32 }}>
                                {[
                                    { label: "SR No" },
                                    { label: "Sauda Date" },
                                    { label: "Awak No" },
                                    { label: "Farmer Code" },
                                    { label: "Farmer Name" },
                                    // { label: "City" },
                                    { label: "Qty" },
                                    { label: "Item Name" },
                                    { label: "GoDown Name" },
                                    { label: "Line Name" },
                                    { label: "Balance" },
                                    { label: "Remove" },
                                ].map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            ...styles.tableHeaderCell,
                                            textAlign: "center", // if you want right alignment for some column, you can add column.format
                                            padding: "4px 6px",
                                            fontSize: "14px",
                                            height: "32px",
                                        }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {selectedHelpRows.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={12} align="center" style={{ fontSize: "16px", fontWeight: "bold" }}>
                                        No data found...
                                    </TableCell>
                                </TableRow>
                            ) : (
                                selectedHelpRows.map((row, index) => (
                                    <TableRow key={row.AwakDetailId} sx={{                    // smaller row height
                                        cursor: "pointer",                // optional: pointer on hover
                                        transition: "background-color 0.3s ease",
                                        "&:hover": { backgroundColor: "#f3f388" }, // optional: hover effect
                                    }}>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.SrNo > 0 ? row.SrNo : lastSrNo + index + 1}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.SaudaDate}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Doc_No}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Ac_code}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Ac_Name_E}</TableCell>
                                        {/* <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.city_name_e}</TableCell> */}
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Awak_Qty}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Item}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Godown}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.Line}</TableCell>
                                        <TableCell sx={{ fontSize: 12, textAlign: "center", py: 0.5 }}>{row.balance}</TableCell>
                                        <TableCell sx={{ textAlign: "center", py: 0.5 }}>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                                sx={{
                                                    minWidth: "22px",
                                                    height: "22px",
                                                    padding: 0,
                                                    fontSize: "12px",
                                                    lineHeight: 1,
                                                    borderRadius: "50%",
                                                }}
                                                onClick={() => handleRemoveSelectedRow(row[rowKey])}
                                            >
                                                X
                                            </Button>
                                        </TableCell>


                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>

                </TableContainer>
            </Paper>

            {/* LOCK BUTTON */}
            <Box mt={2} display="flex" justifyContent="center">
                <button
                    onClick={handleCarryToAuction}
                    className="btn btn-primary"
                    disabled={selectedHelpRows.length === 0}
                    style={{
                        opacity: selectedHelpRows.length === 0 ? 0.6 : 1,
                        cursor: selectedHelpRows.length === 0 ? "not-allowed" : "pointer"
                    }}
                >
                    Lock Sauda
                </button>
            </Box>

            {/* PAGINATION */}
            <Box mt={3} mb={5}>
                <Pagination
                    pageCount={pageCount}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </Box>
        </>
    );
};

export default CarryToAuctionUtility;
